import { useState, useEffect } from 'react';
import Table from '../../components/Table/Table';
import { useNavigate } from 'react-router-dom';
import config from '../../config';
import ConfirmModal from '../../Models/ConfirmModal';
import StockModel from '../../Models/Stock Models/StockModel';

function CurrentStock() {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [data, setData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedStock, setSelectedStock] = useState(null);
  const [showStockModel, setStockModal] = useState(false);
  const [rawStock, setRawStock] = useState([]);


  const columns = ['#', 'Stock Name', 'Stocked Date', 'Product Name', 'Product Code', 'Category', 'Unit Price', 'Quantity', 'Value', 'Supplier', 'Status'];
  const btnName = '+ New Stock';

  const navigate = useNavigate();

  useEffect(() => {
    fetchStock();
  }, []);

  const fetchStock = async () => {
    try {
      const response = await fetch(`${config.BASE_URL}/stocks`);
      if (!response.ok) {
        throw new Error('Failed to fetch stock list');
      }
      const stock = await response.json();
      setRawStock(stock);
      const formattedData = stock.map((stock) => {

        const stockDate = new Date(stock.stockDate);
        const formattedStockDate = `${stockDate.getFullYear()}-${String(stockDate.getMonth() + 1).padStart(2, '0')}-${String(stockDate.getDate()).padStart(2, '0')} ${String(stockDate.getHours()).padStart(2, '0')}:${String(stockDate.getMinutes()).padStart(2, '0')}`;

        return [
          stock.stockId,
          stock.stockName || '-',
          formattedStockDate,
          stock.product?.productName || 'Unknown',
          stock.product?.productCode || 'Unknown',
          stock.category?.categoryName || "-",
          stock.unitPrice,
          stock.stockQty,
          stock.stockPrice,
          stock.supplier?.supplierName || 'Unknown',
          <select
            className='form-control'
            value={stock.stockStatus}
            onChange={(e) => handleStatusChange(stock.stockId, e.target.value)}
            disabled={stock.stockQty === 0}
          >
            <option value="In stock">In stock</option>
            <option value="Out of Stock">Out of Stock</option>
          </select>
        ]
      });

      setData(formattedData);
      setIsLoading(false);
    } catch (err) {
      setError(err.message);
      setIsLoading(false);
    }
  };

  const handleStatusChange = async (stockId, newStatus) => {
    try {
      const response = await fetch(`${config.BASE_URL}/stock/${stockId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ stockStatus: newStatus }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        setError(`Failed to update stock status: ${response.status} ${response.statusText}. ${errorData.message || ''}`);
      }
      await fetchStock();
    } catch (error) {
      setError(`Error updating stock status: ${error.message}`);
    }
  };

  const confirmDelete = async () => {
    try {
      const stockId = data[selectedStock][0];

      const response = await fetch(`${config.BASE_URL}/stock/${stockId}`, {
        method: 'DELETE',
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(`Failed to delete stock: ${response.status} ${response.statusText}. ${errorData.message || ''}`);
      }

      // setData(prevData => prevData.filter((_, index) => index !== selectedStock));
      await fetchStock();
    } catch (err) {
      setError(`Error deleting stock: ${err.message}`);
    } finally {
      setIsModalOpen(false);
      setSelectedStock(null);
    }
  };

  const handleEdit = (originalIndex) => {
    const selectedStockItem = rawStock[originalIndex];

    setSelectedStock({
      stockId: selectedStockItem.stockId,
      stockName: selectedStockItem.stockName,
      stockDate: selectedStockItem.stockDate,
      product: selectedStockItem.product,
      category: selectedStockItem.category?.categoryId,
      unitPrice: selectedStockItem.unitPrice,
      stockQty: selectedStockItem.stockQty,
      stockPrice: selectedStockItem.stockPrice,
      supplier: selectedStockItem.supplier,
      stockStatus: selectedStockItem.stockStatus,
    });

    setStockModal(true);
  };

  const handleDelete = (originalIndex) => {
    setSelectedStock(originalIndex);
    setIsModalOpen(true);
  };

  const cancelDelete = () => {
    setIsModalOpen(false);
    setSelectedStock(null);
  };

  const handleCloseModal = () => {
    setStockModal(false);
  };

  const handleNewStockClick = () => {
    navigate('/stock/new-stock');
  };

  const title = 'Current Stock';
  const invoice = 'Current Stock.pdf';

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;
  return (
    <div>
      <div className="scrolling-container">
        <h4>Current Stock</h4>
        <Table
          search={'Search by Product Name'}
          data={data}
          columns={columns}
          btnName={btnName}
          onAdd={handleNewStockClick}
          showActions={true}
          onMarkOutOfStock={null}
          title={title}
          invoice={invoice}
          showDate={false}
          showEdit={true}
          onDelete={handleDelete}
          onEdit={handleEdit}
          itemsPerPageOptions={[10, 25, 50, 100, -1]}
        />

        {isModalOpen && (
          <ConfirmModal
            onConfirm={confirmDelete}
            onClose={cancelDelete}
          />
        )}

        <StockModel
          showModal={showStockModel}
          closeModal={handleCloseModal}
          selectedStock={selectedStock}
          onSave={fetchStock}
        />

      </div>
    </div>
  )
}

export default CurrentStock;